import React from "react";
import useResponsive from "../../hooks/useResponsive";

const ResponsiveGrid = ({
  children,
  columns = 4,
  gap = 20,
}) => {
  const { isMobile, isTablet } = useResponsive();

  let gridColumns;

  if (isMobile) {
    gridColumns = 1;
  } else if (isTablet) {
    gridColumns = Math.min(2, columns);
  } else {
    gridColumns = columns;
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))`,
        gap,
        width: "100%",
        alignItems: "stretch",
      }}
    >
      {children}
    </div>
  );
};

export default ResponsiveGrid;
